'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/events/resell/Button.tsx
import { useResellConfig, useRouter, useTranslation } from "@wbk/config";
import { Button, Typography } from "@wbk/ui";
import { useAnalytics } from "@wbk/analytics";
import { jsx } from "react/jsx-runtime";
var ResellButton = (_a) => {
  var _b = _a, { slug, title } = _b, props = __objRest(_b, ["slug", "title"]);
  const { t } = useTranslation("contentful_event");
  const { locale } = useRouter();
  const { domain } = useResellConfig();
  const { trackEvent } = useAnalytics();
  return /* @__PURE__ */ jsx(
    Button,
    __spreadProps(__spreadValues({
      className: "h-12 w-full",
      as: "a",
      href: `${domain}/${locale}/events/${slug}`,
      target: "_blank",
      rel: "noopener noreferrer"
    }, props), {
      onClick: () => trackEvent({
        event: "clicked_on_resell_button",
        data: { event_slug: slug, button_location: "event_page_resell_button" }
      }),
      children: title || /* @__PURE__ */ jsx(Typography, { variant: "body-L", strong: true, children: t("contentful_event:resell.check_tickets") })
    })
  );
};
var Button_default = ResellButton;

export {
  Button_default
};
//# sourceMappingURL=chunk-KPHPJUNU.mjs.map